import dayjs from "dayjs";

export default {
  name: "pay-date",
  computed: {
    showPayDate() {
      return this.params.value
        ? dayjs(this.params.value).format(
            this.$i18n.locale == "fa" ? "YYYY/MM/DD" : "YYYY/DD/MM"
          )
        : this.$t("giftsPage.endOfCampain");
    }
  }
};
